import { ApolloClient, InMemoryCache, createHttpLink, ApolloLink} from "@apollo/client"
import { setContext } from '@apollo/client/link/context';
import { onError } from "@apollo/client/link/error";

const GRAPHQL_ENDPOINT = process.env.REACT_APP_ZEUS_HOST+'/graphql';

const httpLink = createHttpLink({
    uri: GRAPHQL_ENDPOINT,
});

const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem("_token");
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
        }
    }
});


const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    console.log(graphQLErrors);
    if (graphQLErrors)
        graphQLErrors.forEach(( element ) =>{
            console.error(`[GraphQL error]: Message: ${element.message}, Operation: ${operation.operationName}, Path: ${element.path}`)
            if(element.message === "Unauthorized"){
                localStorage.removeItem("_token");
                window.location.reload();
            }
        }
      );
    if (networkError) console.error(`[Network error]: ${networkError}`);
  });

const client = new ApolloClient({
    link: ApolloLink.from([errorLink, authLink, httpLink]),
    cache: new InMemoryCache()
});

export default client;

